import React, { useState, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { IoMdCloseCircle } from "react-icons/io";
import logo from '../Assets/Images/Caduceus 512x512.gif'
import DropdownButton from 'react-bootstrap/DropdownButton';
import { LiaAngleDownSolid } from "react-icons/lia";
import { IMAGE_URL } from "../API";
import { ProfileContext } from "../context/ProfileContext";
import avtar from "../Assets/Images/image copy 2.png";
import { logout as authLogout, clearAuthData } from "../services/authService";

function Header2() {
  const [show, setShow] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const navigate = useNavigate()
  const location = useLocation()
  const { profile, isProfileIncomplete, TOKEN } = useContext(ProfileContext);
  const handleClose = () => { setShow(false); }
  const handleShow = () => { setShow(true); }
  const handleLogout = async () => {
    setIsLoggingOut(true);
    await authLogout(navigate);
    setShow(false);
    setIsLoggingOut(false);
  };
  return (
    <>
      <div className="site_header">
        <div className="container">
          <div className="d-flex site_header_inner">
            <Link to="/" className="site_header_logo">
              <img src={logo} alt="" className="img-fluid" />
            </Link>

            {TOKEN ?
              (<div id="header_dropdown" style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                {location.pathname !== "/" && <Link to="/" style={{ fontSize: "18px", fontWeight: "700" }}>Home</Link>}
                <DropdownButton
                  align="end"
                  title={
                    <div className="cst_header_drop_name_row">
                      <figure className="prf_img">
                        <img src={profile.image ? `${IMAGE_URL}${profile.image}` : avtar} alt="" className="img-fluid" />
                      </figure>
                      <p className="name text-capitalize">{profile.full_name}</p>
                      <LiaAngleDownSolid />
                    </div>
                  }>
                  <div className="cst_header_drop_name_row drop_inner">
                    <figure className="prf_img">
                      <img src={profile.image ? `${IMAGE_URL}${profile.image}` : avtar} alt="" className="img-fluid" />
                    </figure>
                    <div>
                      <p className="name text-capitalize">{profile.full_name}</p>
                      <p className="email text-lowercase">{profile.email}</p>
                    </div>
                  </div>
                  <Link to={!isProfileIncomplete(profile) ? '/profile-page' : '/profile'} className="dropdown-item">
                    View Profile
                  </Link>
                  <Link to={'/consultation-history'} className="dropdown-item">
                    Consultation History
                  </Link>
                  <Link className="dropdown-item" onClick={handleShow} >Logout</Link>
                </DropdownButton>
              </div>)
              :
              (<div className="site_header_btns">
                <button className='main-outline-btn' onClick={() => navigate('/registration')}> Register </button>
                <button className='main-btn' onClick={() => navigate('/login')}> Login </button>
              </div>)
            }
          </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose} centered className="comm_modal logout_modal">
        <Modal.Body className="p-0">
          <Modal.Header><IoMdCloseCircle onClick={handleClose} /></Modal.Header>
          <div className="comm_inner_body_modal">
            <h4>Are you sure you want to logout?</h4>
            <div className="modal_pair_btns">
              <button className='main-outline-btn' onClick={handleClose} disabled={isLoggingOut}>No</button>
              <button className='main-btn' onClick={handleLogout} disabled={isLoggingOut}>
                {isLoggingOut ? 'Logging out...' : 'Yes'}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default Header2;